// 提供一个能够显示xtx-message組件的函數
// 这个函數将来：导入直接使用，也可以挂载在vue实例原型上
// import Message from 'Message.js' 使用 Message({type:'error',text:'提示文字'})
// this.$message({type:'error',text:'提示文字'})

import { createVNode, render } from 'vue'
import XtxMessage from './xtx-message.vue'

// DOM容器
const div = document.createElement('div')
div.setAttribute('class', 'xtx-msssage-container')
document.body.appendChild(div)

// 定时器标识
let timer = null

export default ({ type, text }) => {
  // 渲染組件
  // 1. 导入消息提示組件
  // 2. 将消息提示組件编译为虚拟节点(dom节点)
  // createVNode(組件,属性對象（props）)
  const vnode = createVNode(XtxMessage, { type, text })
  // 3. 准备一个装载消息提示組件的DOM容器
  // 4. 将虚拟节点渲染再容器中
  // render(虚拟节点,DOM容器)
  render(vnode, div)
  // 5. 3s后销毁組件
  clearTimeout(timer)
  timer = setTimeout(() => {
    render(null, div)
  }, 3000)
}
